import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { COMMON_TEXT } from '@/helpers/common-text';
import LoadingSpinner from '@/components/CustomComponent/LoadingSpinner';
import './CustomHorizontalBarChart.less';

class CustomHorizontalBarChart extends Component {
  render() {
    let {
      data = [],
      xAxisDataKey,
      yAxisDataKey,
      isLoading,
      headers = {
        nameColumn: '端末名',
        valueColumn: '台',
        barColumn: ''
      },
      columnWidths = {
        nameColumn: '35%',
        valueColumn: '10%',
        barColumn: '55%'
      },
      valueFormatter = (value) => value
    } = this.props;

    const isEmptyData = data.length === 0;

    if (isLoading) {
      return (
        <div className="custom-horizontal-bar-chart">
          <div className="loading-container">
            <div className="loading-layer">
              <LoadingSpinner />
            </div>
          </div>
        </div>
      );
    }

    if (isEmptyData) {
      return (
        <div className="custom-horizontal-bar-chart">
          <div className="loading-container">
            <div className="loading-layer">
              <div className="no-data-container">
                {COMMON_TEXT.NO_DATA}
              </div>
            </div>
          </div>
        </div>
      );
    }

    // Find max value for scaling
    const maxValue = Math.max(...data.map(item => item[yAxisDataKey] || 0));

    return (
      <div className="custom-horizontal-bar-chart">
        <table className="chart-table">
          <thead className="table-header">
            <tr>
              <th className="device-name-header" style={{ width: columnWidths.nameColumn }}>
                {headers.nameColumn}
              </th>
              <th className="count-header" style={{ width: columnWidths.valueColumn }}>
                {headers.valueColumn}
              </th>
              <th className="bar-header" style={{ width: columnWidths.barColumn }}>
                {headers.barColumn}
              </th>
            </tr>
          </thead>
          <tbody className="table-body">
            {data.map((item, index) => {
              const deviceName = item[xAxisDataKey] || '';
              const value = item[yAxisDataKey] || 0;
              const color = item.fillColor || '#4A90E2';
              const barWidth = maxValue > 0 ? (value / maxValue) * 100 : 0;

              return (
                <tr key={`bar-row-${index}`}>
                  {/* Column 1: Name Column */}
                  <td className="device-name-cell" style={{ width: columnWidths.nameColumn }}>
                    {deviceName}
                  </td>

                  {/* Column 2: Value Column */}
                  <td className="count-cell" style={{ width: columnWidths.valueColumn }}>
                    {valueFormatter(value)}
                  </td>

                  {/* Column 3: Bar */}
                  <td className="bar-cell" style={{ width: columnWidths.barColumn }}>
                    <div className="bar-container">
                      <div
                        className="bar-fill"
                        style={{
                          width: `${Math.max(barWidth * 0.8, value > 0 ? 5 : 0)}%`,
                          maxWidth: '80%',
                          backgroundColor: color
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

CustomHorizontalBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  xAxisDataKey: PropTypes.string.isRequired,
  yAxisDataKey: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  headers: PropTypes.shape({
    nameColumn: PropTypes.string,
    valueColumn: PropTypes.string,
    barColumn: PropTypes.string
  }),
  columnWidths: PropTypes.shape({
    nameColumn: PropTypes.string,
    valueColumn: PropTypes.string,
    barColumn: PropTypes.string
  }),
  valueFormatter: PropTypes.func
};

export default CustomHorizontalBarChart; 